/**
 * 统一设置getter
 */

export default {
  isMobile: state => state.device.isMobile
}
